<template>
  <div v-if="!showInteresado() || !isCitizen()" class="container__suscriptorSearch">
    <div class="container__suscriptorSearch--title">
      <i class="icon__interesados--container icon-ayudadigital-interesados-negativo"></i>
      <h1 class="title__interesados--container">Interesados</h1>
    </div>

    <span class="text__subtitle m-1">{{ $t("ticketActions.interesado.subtitle") }}</span>

    <v-autocomplete
      class="input__search--interesado"
      :outlined="!disabled"
      :filled="disabled"
      ref="autocomplete"
      v-model="value"
      :search-input.sync="query"
      :hide-details="'auto'"
      :label="label"
      :persistent-hint="hint !== ''"
      :hint="this.isTotalCenter ? this.labelMacCenter : hint"
      :disabled="disabled"
      :loading="loading"
      :items="items"
      :placeholder="params.placeholder || label"
      :item-text="itemText"
      :item-value="params.value || 'id'"
      :multiple="isMultiple"
      :no-filter="true"
      :clearable="!required"
      :no-data-text="messageEmpty"
      :rules="rules"
      :hide-no-data="!isEmpty"
      @click="isEmpty = false"
      @keydown="handleSearch($event)"
      @change="emitInputData"
    >
      <template v-if="$slots.required" v-slot:prepend-inner>
        <slot name="required"></slot>
      </template>

      <!-- SLOT PARA SCROLL INFINITO -->
      <template v-slot:append-item>
        <div v-intersect="endIntersect" />
      </template>

      <template v-slot:no-data v-if="params.nodatamessage">
        <v-list-item>
          <v-list-item-title>
            {{params.nodatamessage}}
            <strong v-if="params.extraFilter">
              {{$t('components.search.noDataMessage')}}
              <v-icon size="20">
                mdi-filter-plus-outline
              </v-icon>
              {{$t('components.search.noDataMessageContinue')}}
            </strong>
          </v-list-item-title>
        </v-list-item>
      </template>

      <template v-slot:append>
        <v-icon v-if="!loading">mdi-magnify</v-icon>
        <v-progress-circular
          v-else
          color="primary"
          indeterminate
          size="25"
        >
        </v-progress-circular>
      </template>

      <template v-slot:append-outer v-if="params.extraFilter || (isMobile && isBarcodeScan)">
        <v-btn
          icon
          color="primary"
          v-if="params.extraFilter"
          @click="openModal = !openModal"
        >
          <v-icon size="30" class="mb-4">
            mdi-filter-plus-outline
          </v-icon>
        </v-btn>
        <ExtendedSearch
          v-if="openModal && params.extraFilter"
          :filtersSearch="evalParam(params.extraFilter)"
          :filters="evalParam(params.filters)"
          :params="params"
          :title="label"
          @close="openModal = false"
          @send="getResultExtendedSearch($event)"
        >
        </ExtendedSearch>
      </template>
    </v-autocomplete>

    <v-card class="card__container" v-if="itemsList.length > 0">
      <template>
        <v-chip
          v-for="(item, i) in itemsList"
          :key="i"
          class="ma-2"
          :model-value="true"
        >
          {{ item.name }}
          <span class="btn__delete__interesado" @click="deleteItem($event, item)">
            <v-icon>mdi-delete</v-icon>
          </span>
        </v-chip>
      </template>
    </v-card>

    <p
      v-if="this.itemsList.length === 10"
      class="text__interesado__help text__interesado__error"
    >
      {{ $t("views.ticketDetail.subscriptions.max") }}
    </p>
    <p
      v-if="this.itemsList.length === 0"
      class="text__interesado__help"
    >
      {{ $t("views.ticketDetail.subscriptions.noBody") }}
    </p>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState } from 'vuex';
import Search from '../field-types/Search.vue';

const COMPONENT_MATCH_FIELDS = ['zdni', 'userid', 'first_name', 'middle_name', 'last_name'];

function getDelimiter(val) {
  return val.includes(',') ? ',' : ' ';
}

export default {
  name: 'SuscriptorSearch',
  extends: Search,
  data() {
    return {
      elementMax: 10,
      selectedCount: 0,
      itemsList: [],
      idList: '',
      openModal: false,
    };
  },
  props: {
    showMaxResults: Boolean,
    sections: {
      type: Array,
      default: () => ([]),
    },
    cancelable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  created() {
    this.$root.$on('contactSuscriptor', (data) => {
      const { alias } = data;
      if (alias === 'interesados') {
        this.handleContactSuscriptorInteresado(data);
      }
    });
  },
  methods: {
    matchToFilters(queryValue) {
      const { match } = this.params;

      if (queryValue.includes(',') || !queryValue.includes(' ')) {
        const query = queryValue.trim().replace(/ +/i, ' ').replace(/ /i, '%').toUpperCase();
        const delimiter = getDelimiter(queryValue);

        // if query value has some ','
        if (queryValue.includes(delimiter)) {
          const splitted = queryValue.split(delimiter);
          const numberOfOcurrences = (queryValue.match(new RegExp(delimiter, 'g')) || []).length;
          let keys;
          switch (numberOfOcurrences) {
          case 3:
            keys = ['middle_name', 'last_name', 'first_name', 'location.name'];
            break;
          case 2:
            keys = ['middle_name', 'last_name', 'first_name'];
            break;
          case 1:
          default:
            keys = ['middle_name', 'last_name'];
          }
          return [keys.reduce((acum, key, idx) => {
            acum[key] = { $regex: `%${splitted[idx].trim().toUpperCase()}%` };
            return acum;
          }, {})];
        }

        // get match param for extra matching fields
        const matchP = (typeof match === 'string' ? match.split(',') : [])
          .filter((field) => !COMPONENT_MATCH_FIELDS.includes(field))
          .concat(COMPONENT_MATCH_FIELDS);

        return matchP.map((param) => ({ [param]: { $regex: `%${query}%` } }));
      }

      const fullNameQuery = `%${queryValue.replace(/ /g, '%').toUpperCase()}%`;
      return {
        full_name_contact_search: { $regex: fullNameQuery },
      };
    },
    handleContactSuscriptorInteresado(data) {
      this.handleContactSuscriptor(data);
    },
    handleContactSuscriptor(data) {
      const { item, value } = data;
      if (item && value && this.itemsList.length < this.elementMax) {
        const isUserSelected = this.itemsList.find((itemInteresado) => itemInteresado.id === value);
        if (isUserSelected) return;

        this.itemsList.push({
          name: `${ item.middle_name || '' } ${ item.last_name || '' } ${ item.first_name || '' }`,
          id: value,
          dni: item.zdni,
        });
      }

      localStorage.setItem('suscriptorsList', JSON.stringify(this.itemsList));

      const allInputs = document
        .querySelectorAll('label.v-label--active.theme--light.primary--text');
      allInputs.forEach((elemento) => {
        if (elemento.textContent.trim() === 'Interesados') {
          const boton = elemento
            .closest('.v-select__slot').querySelector('.v-input__icon--clear button');
          if (boton) {
            boton.click();
          }
        }
      });
      this.items = [];
    },
    deleteItem(evt, itemSusciptor) {
      const filteredNames = this.itemsList.filter((item) => item.id !== itemSusciptor.id);

      this.itemsList = filteredNames;
      localStorage.setItem('suscriptorsList', JSON.stringify(this.itemsList));
    },
    evalParam(param, v) {
      const str = typeof param === 'function' ? param({ value: v }) : param;
      try {
        return JSON.parse(str || '{}');
      } catch (ex) {
        return str;
      }
    },
    async getResultExtendedSearch($evt) {
      try {
        this.openModal = false;

        const { target, entity, fields } = this.params;
        const result = await this.client.search({
          target, entity, fields, filters: { id: $evt.id },
        });

        const valueItem = result.unique();

        if (valueItem && this.itemsList.length < this.elementMax) {
          const isUserSelected = this.itemsList
            .find((itemInteresado) => itemInteresado.id === valueItem.id);
          if (isUserSelected) return;

          this.itemsList.push({
            name: `${ valueItem.middle_name || '' } ${ valueItem.last_name || '' } ${ valueItem.first_name || '' }`,
            id: valueItem.id,
            dni: valueItem.zdni,
          });
          localStorage.setItem('suscriptorsList', JSON.stringify(this.itemsList));
        }
      } catch (ex) {
        console.error('error in initialsearch', ex);
      }
    },
    showInteresado() {
      const sectionAll = this.sections.flatMap((section) => section.fields || []);

      const interesadosElement = sectionAll.find((element) => element.alias === 'interesados');
      if (!interesadosElement) {
        return false;
      }

      const deshabilitarCrearElement = sectionAll.find((element) => element.config?.disableSubmit === 'true');

      if (deshabilitarCrearElement !== null && deshabilitarCrearElement !== undefined) return true;

      return false;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
};
</script>
<style>
.card__container {
  padding: 0.5rem 1rem;
}
.card__item {
  margin: 0.5rem 0;
}
.card__info {
  display: flex;
  justify-content: space-between;
}
.container__btnExpand {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
}

.icon-background {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 13.5px;
}

.adjuntChip {
  border: 2px solid #f1f1f1 !important;
}

.container__userCustomer {
  margin-top: 1rem;
}

.card__element_suscriptores div {
  padding: 0;
}

.btn__delete__interesado {
  cursor: pointer;
}

.container__suscriptorSearch {
  border: 1px solid #afadad;
  position: relative;
  padding: 1.5rem;
  margin-top: 1rem;
}
.container__suscriptorSearch--title {
  position: absolute;
  top: -31px;
  left: 17px;
  background-color: #ffffff;
  padding-right: 1rem;
  display: flex;
  align-items: center;
}
.icon__interesados--container {
  font-size: 4rem;
}
.title__interesados--container {
  font-size: 1.2rem;
}
.m-1 {
  margin: 1rem 0;
}
.text__subtitle {
  font-size: .9rem;
  margin-bottom: 1rem;
}
.text__interesado__help {
  font-size: 10.4px !important;
  margin-top: 0.3rem;
  margin-bottom: 0 !important;
}
.text__interesado__error {
  color: #b64351 !important;
  margin-top: 0.5rem;
}
.input__search--interesado {
  margin-top: 1rem !important;
}
</style>
